import styled from 'vue-styled-components'
const ReHeight = styled.div`
  pointer-events: all;
  position: absolute;
  width: 56px;
  height: 8px;
  background-color: #12A9FF;
  border: 1px solid #12A9FF;
  border-radius: 0px 0px 10px 10px;
  bottom: -7px;
  box-shadow: 1px 1px #0000004f;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2;
  max-width: 100%;
  cursor: row-resize;
`
const ToolLabel = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  white-space: nowrap;
  height: 25px;
  width: fit-content;
  top: 5px;
  left: 100%;
  border-radius: 4px;
`
export {
  ReHeight,
  ToolLabel
}